/**
 * Logo Widget
 *
 * Renders SVG logo from backend definition.
 * Backend can provide:
 * - svg_content: Raw SVG string
 * - width/height: Dimensions
 * - css_style: Custom styles
 */

import React from 'react';
import type { WidgetProps } from './registry';

export const LogoWidget: React.FC<WidgetProps> = ({ widget }) => {
  const { svg_content, width = 80, height = 80, css_style } = widget;

  return (
    <div
      className="rul-widget-logo"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '2rem',
        ...css_style,
      }}
    >
      {svg_content ? (
        <div
          dangerouslySetInnerHTML={{ __html: svg_content }}
          style={{ width, height }}
        />
      ) : (
        // Default logo if backend doesn't provide svg_content
        <svg
          width={width}
          height={height}
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {[0, 1, 2, 3, 4].map((row) =>
            [0, 1, 2, 3, 4].map((col) => {
              const isCenter = row === 2 && col === 2;
              const x = 16 + col * 12;
              const y = 16 + row * 12;
              const r = isCenter ? 6 : 3;
              return (
                <circle
                  key={`${row}-${col}`}
                  cx={x}
                  cy={y}
                  r={r}
                  fill="currentColor"
                />
              );
            })
          )}
        </svg>
      )}
    </div>
  );
};
